import { Box, Checkbox, FilledInput, FormControl, Grid, IconButton, InputAdornment, InputLabel, ListItemText, MenuItem, Select, Typography } from '@mui/material';
import { AspectRatioRounded, Search } from '@mui/icons-material';
import useAspectRatio from '../../../../hooks/useAspectRatio';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedDivisionClass } from '../../../../store/actions/dbwVsTarget';
import { getDateInfo } from '../../../../utils/dateInfo';
import styles from './styles';
import { useEffect, useState } from 'react';
import { REDUX_ACTIONS } from '../../../../shared/config/constants';
import { MARKETSHARE_CLASSES } from '../../../../utils/constants';

const MarketshareKPIControls = () => {
  const classes = styles();
  const handleAspectRatio = useAspectRatio();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const { preferences } = useSelector((state) => state.currentUser);
  const { startDate, endDate, loading } = useSelector((state) => state.dbwVsTarget);
  const { divisions, selectedDivision, selectedClasses, searchTerm, loading: kpisLoading } = useSelector((state) => state.dbwVsTarget.kpis);
  const params = new URLSearchParams(window.location.search);
  const urlFilters = {
    division: params.get('division'),
    classes: params.getAll('classes'),
  };

  useEffect(() => {
    if (urlFilters.division && urlFilters.classes && !kpisLoading) {
      dispatch(setSelectedDivisionClass(urlFilters.division, urlFilters.classes, searchTerm));
    }
  }, [kpisLoading]);

  const handleDivisionChange = (e) => {
    dispatch(setSelectedDivisionClass(e.target.value, selectedClasses, searchTerm));
  };

  const handleClassesChange = (e) => {
    if (e.target.value.length === 0) return;
    dispatch(setSelectedDivisionClass(selectedDivision, e.target.value, searchTerm));
    setOpen(false);
  };

  const handleSearchChange = (e) => {
    dispatch({
      type: REDUX_ACTIONS.MARKETSHARE_KPIS_LIST_SEARCH_CHANGE,
      payload: e.target.value
    });
  };

  const handleSearch = () => {
    dispatch(setSelectedDivisionClass(selectedDivision, selectedClasses, searchTerm));
  };

  return (
    <Grid alignItems="flex-end" justifyContent="flex-end" sx={{ width: '80%' }}>
      <Box className={classes.container}>
        <Box className={classes.dateContainer}>
          {startDate && endDate && (
            <>
              <Typography variant='body2' className={classes.dateText}>{getDateInfo(new Date(startDate), '/').formated}</Typography>
              <Typography variant='body2' className={classes.dateText}><span style={{ margin: '0 10px' }}>-</span>{getDateInfo(new Date(endDate), '/').formated}</Typography>
            </>
          )}
        </Box>
        <Box className={classes.divisionContainer}>
          <Typography variant='body2' className={classes.divisionText}>Classes</Typography>
          <FormControl variant='outlined' sx={{ minWidth: '180px' }}>
            <Select
              labelId="simple-select-multiple-label"
              id="simple-select-multiple"
              multiple
              open={open}
              onClose={() => setOpen(false)}
              onOpen={() => setOpen(true)}
              value={selectedClasses}
              onChange={handleClassesChange}
              size='small'
              renderValue={(selected) => selected.join(', ')}
              sx={{
                '& .MuiSelect-select': {
                  padding: '14px',
                },
              }}
              disabled={loading}
              MenuProps={{
                disableAutoFocusItem: true,
              }}
            >
              {MARKETSHARE_CLASSES?.sort().map((item) => (
                <MenuItem
                  key={`item_${item}`}
                  value={item}
                  sx={{
                    '&.Mui-selected': {
                      backgroundColor: 'transparent',
                    },
                    '&.Mui-selected:hover': {
                      backgroundColor: 'rgba(0, 0, 0, 0.04)', // subtle hover only
                    },
                  }}
                >
                  <Checkbox checked={selectedClasses.indexOf(item) > -1} disabled={selectedClasses.length === 1} />
                  <ListItemText primary={item} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Box display='flex' alignItems='center' sx={{ ml: 2 }}>
            <Typography variant='body2' className={classes.divisionText}>Division</Typography>
            <FormControl variant='outlined' sx={{ minWidth: '180px' }}>
              <Select
                labelId="simple-select-standard-label"
                id="simple-select-standard"
                value={selectedDivision}
                onChange={handleDivisionChange}
                size='small'
                sx={{
                  '& .MuiSelect-select': {
                    padding: '14px',
                  },
                }}
                disabled={loading}
              >
                <MenuItem
                  key={'ALL'}
                  value={'ALL'}
                >
                  ALL
                </MenuItem>
                {divisions?.sort().map((item) => (
                  <MenuItem
                    key={`item_${item}`}
                    value={item}
                  >
                    {item}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </Box>
        <Box sx={{ m: '0 5px' }}>
          <FormControl>
            <InputLabel
              htmlFor="outlined-adornment-search"
              inputprops={{ classes: { root: classes.searchBar } }}
            >
              Search
            </InputLabel>
            <FilledInput
              className={classes.searchBar}
              id="outlined-adornment-search"
              type="text"
              label="Search"
              value={searchTerm || ''}
              onChange={handleSearchChange}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    edge="end"
                    onClick={handleSearch}
                  >
                    <Search />
                  </IconButton>
                </InputAdornment>
              }
            />
          </FormControl>
        </Box>
        <Box>
          <IconButton
            edge="end"
            onClick={() => {
              handleAspectRatio(!preferences.aspectChanged);
            }}
          >
            <AspectRatioRounded />
          </IconButton>
        </Box>
      </Box>
    </Grid>
  );
};

export default MarketshareKPIControls;
